// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"312":"8a87f873","354":"1fbd749e","364":"d0290b3c","405":"497e31e2","599":"5af9a381","872":"aea34c12","925":"b10b62e8"}[chunkId] + ".css";
};